import { render } from "./project.vue?vue&type=template&id=4f6df355&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"

import "./project.vue?vue&type=style&index=0&id=4f6df355&lang=less&scoped=true"

import exportComponent from "D:\\00project\\36live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6df355"]])

export default __exports__